const SUPPORTED_API_LANGUAGES = new Set(["en", "tr", "es"]);

export const normalizeApiLanguage = (language?: string | null): string => {
  if (!language) {
    return "en";
  }

  const normalized = language.trim().toLowerCase();
  if (!normalized) {
    return "en";
  }

  const baseLanguage = normalized.split("-")[0];
  if (SUPPORTED_API_LANGUAGES.has(baseLanguage)) {
    return baseLanguage;
  }

  return "en";
};
